module.exports = __webpack_public_path__ + "img/sun.37f5b7be.svg";